function join(before, addItem) {
    return before
        .split("/")
        .filter(x => x)
        .concat(addItem)
        .join("/");
}
export function parse(list, pItem = {}, init) {
    const { url: prefix = "", id: pid = "", list: plist = [] } = pItem;
    const { map = {} } = init || {};
    list.forEach(one => {
        const { path, menu, children, permit } = one;
        const url = join(prefix, path);
        const id = url; // join(pid, index);
        if (menu) {
            const { icon, title, type, i18n } = menu;
            const list = [];
            map[id] = { id, title, url, icon, list, pid, type, permit, i18n };
            if (pid) {
                plist.push(map[id]);
            }
        }
        if (children) {
            parse(children, { ...map[menu ? id : pid], url }, { map });
        }
    });
    if (!init) {
        const result = [];
        Object.keys(map).map(key => {
            const one = map[key];
            if (!one.pid) {
                result.push(one);
            } else {
                const childrenList = (map[one.pid].children = map[one.pid].children || []);
                childrenList.push(one);
            }
        });
        return result;
    }
}
